export default __webpack_public_path__ + "static/media/close.5ff1f060.svg";